import { useAuthStore } from '@/auth/authStore';
import { SERVER_URL, COMMON_HEADERS } from '@/config/serverUrl';

async function req(method: string, path: string, body: unknown): Promise<void> {
  const token = useAuthStore.getState().token;
  if (!token) return;
  await fetch(`${SERVER_URL}${path}`, {
    method,
    headers: {
      'Content-Type': 'application/json',
      ...COMMON_HEADERS,
      Authorization: `Bearer ${token}`,
    },
    credentials: 'include',
    body: JSON.stringify(body),
  });
}

export const pushApi = {
  /** Upsert this device's FCM token under the current user. */
  register: (token: string, platform: string, locale: string) =>
    req('POST', '/me/push-token', { token, platform, locale }),
  /** Drop the token on logout. */
  unregister: (token: string) => req('DELETE', '/me/push-token', { token }),
};
